import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import * as Swiper from 'swiper/dist/js/swiper.js';
import '../../interfaces/slider.interface';
import './campaign-components.component.scss';
var CampaignComponents = /** @class */ (function (_super) {
    tslib_1.__extends(CampaignComponents, _super);
    function CampaignComponents(element) {
        return _super.call(this, element) || this;
    }
    CampaignComponents.prototype.init = function () {
        var _this = this;
        this.sliderItems = Number(this.element.getAttribute('data-items'));
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        this.sliderButtons = Array.from(this.element.querySelectorAll('.campaign-components__button'));
        this.windowWidth = document.documentElement.clientWidth;
        this.breakpoints = {};
        this.sliderConfig = {
            slidesPerView: 1,
            spaceBetween: 0,
            initialSlide: 0,
            breakpoints: this.breakpoints,
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev,
            }
        };
        if (this.element.getAttribute('data-direction')) {
            if (this.element.getAttribute('data-direction') === 'vertical') {
                this.sliderConfig.direction = 'vertical';
            }
        }
        this.sliderComponent = new Swiper(this.sliderContainer, this.sliderConfig);
        this.sliderComponent.on('slideChange', function (event) {
            var index = _this.sliderComponent.realIndex;
            _this.activeState(index);
        });
    };
    CampaignComponents.prototype.bindEvents = function () {
        var _this = this;
        this.sliderButtons.map(function (item) { return item.addEventListener('click', function (event) {
            var element = undefined;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            var index = element.getAttribute("data-slide");
            _this.sliderComponent.slideTo(index - 1, true);
        }); });
    };
    CampaignComponents.prototype.activeState = function (index) {
        if (index === void 0) { index = 0; }
        var indexSlide = index + 1;
        var buttons = Array.from(this.element.querySelectorAll('.campaign-components__button'));
        buttons.map(function (button) {
            button.classList.remove('campaign-components-item__item--active');
            var buttonIndex = parseInt(button.getAttribute("data-slide"));
            if (indexSlide === buttonIndex) {
                button.classList.add('campaign-components-item__item--active');
            }
        });
    };
    return CampaignComponents;
}(Base));
export { CampaignComponents };



//////////////////
// WEBPACK FOOTER
// ./components/campaign-components/campaign-components.component.ts
// module id = 174
// module chunks = 0